import {useState} from "react";
import Modal from "./Modal";
import Card from "./Card";

function ConfirmButton(props) {
  const {onClick, children, disabled, type, className, icon, color, variant, rounded, reverse} = props;
  const [show, setShow] = useState();
  const title = props.title || "Êtes-vous sûrs ?";
  const message = props.message || "Vous ne pourrez pas revenir en arrière.";

  return (
    <>
      <Modal show={show} setShow={setShow}>
        <Card className={"p-8 flex flex-col gap-8 max-w-[440px]"}>
          <h1 className={"text-xl font-semibold whitespace-normal"}>{title}</h1>
          {typeof message === "string" ? <p className={"text-gray-500"}>{message}</p> : message}
          <div className={"flex w-full justify-end gap-4 whitespace-normal"}>
            <Button onClick={() => setShow(false)} variant={"outline"} color={reverse ? "green" : "red"} className={"w-24"}>
              <span>Non</span>
            </Button>
            <Button onClick={() => {onClick(); setShow(false)}} className={"w-24"} color={reverse ? "red" : "green"}>Oui</Button>
          </div>
        </Card>
      </Modal>
      <Button
        onClick={() => setShow(true)}
        disabled={disabled}
        type={type}
        className={className}
        icon={icon}
        color={color}
        variant={variant}
        rounded={rounded}>
        {children}
      </Button>
    </>
  );
}

function Button(props) {
  const {onClick, children, disabled, type, className, icon} = props;
  const color = props.color || "indigo";
  // variant can be "solid", "outline", "ghost"
  const variant = props.variant || "solid";
  //text-indigo-500 bg-indigo-500 hover:bg-indigo-600 hover:text-white

  let buttonClasses = "px-4 py-2 ";
  buttonClasses += "rounded-" + (props.rounded || "md") + " ";
  if (icon === true) {
    buttonClasses = "rounded-full p-2 ";
  }
  switch (variant) {
    case "outline":
      buttonClasses += "border border-" + color + "-500 text-" + color + "-500 hover:bg-" + color + "-500 hover:text-white";
      break;
    case "ghost":
      buttonClasses += "hover:bg-" + color + "-100 text-" + color + "-500";
      break;
    default:
      buttonClasses += "bg-" + color + "-500 hover:bg-" + color + "-600 text-white";
      break;
  }
  buttonClasses += " " + (className || "");

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type || "button"}
      className={buttonClasses}>
      {children}
    </button>
  );

}

export default Button;
export {ConfirmButton};